import { Button, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import moment from "moment";
import emptyTeacher from "../assets/emptyTeacher.jpg";
import Swal from "sweetalert2";
import cancelButton from "../assets/cancelButton.png";
import youtubeIcon from "../assets/youtubeIcon.png";
import heart from "../assets/heart.png";
import {
    availableDate,
    formatSpeakerProfileTimeslot,
    formatTimeslot,
    formatTimeslotAMPM,
    getAvailableTeacherSate,
    hhformatAMPM,
    localToutcTimeConverter,
    speakerDayTime,
    TimeValidator,
} from "../helpers/TimeDate";
import NotFound from "../assets/notfound.svg";
import { useHistory, useParams } from "react-router-dom";
import {
    AddFavoriteSpeakers,
    RemoveFavoriteSpeakers,
    SpeakerProfile,
} from "../redux/actions/SpeakersAction";
import { useDispatch, useSelector } from "react-redux";
import { TimeSpliter } from "../helpers/planPrice";
import { CreateSession, GetAvalableHost } from "../redux/actions/SessionAction";
import { CreateZoomMeeting } from "../redux/actions/ZoomMeeting";
import { useSnackbar } from "react-simple-snackbar";
import Loder from "../components/loder";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const arr2 = [0, 1, 2, 3, 4, 5, 6];
export const MyVerticallyCenteredModal = (props) => {

    const history = useHistory();
    const dispatch = useDispatch();
    let id = props?.id;
    let attributeOnClick = props?.attributeOnClick;
    // let autoState = props.auto;
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
    const LocalHostUser = JSON.parse(localStorage.getItem("USER"));
    const isTrialClass = JSON.parse(localStorage.getItem("DEMO_SESSION"));
    const setup = JSON.parse(localStorage.getItem("SETUP"));
    const UserPlan = useSelector((state) => state.PlanReducer.currentplan);
    const FavoriteSpeakers = useSelector(
        (state) => state.UserReducer.favoriteSpeakers
    );
    const [openSnackbar, closeSnackbar] = useSnackbar();

    const intervaldate = new Date(
        new Date().toLocaleString("en-US", { timeZone: time_zone.timezone })
    );

    //+4
    intervaldate.setHours(intervaldate.getHours() + parseInt(setup.bookingLag ? setup.bookingLag : "4"));

    const [duration, setDuration] = useState();
    const [weeklyDate, setWeeklyDate] = useState();
    const [selectedDate, setSelectedDate] = useState(availableDate(0).date);
    const [selectedMonth, setSelectedMonth] = useState(availableDate(0).month); //for month
    const [activeDate, setActiveDate] = useState(0);
    const [activeSlot, setActiveSlot] = useState(null);
    const [notfound, setNotFound] = useState(false);
    const [speakerDetails, setSpeakersDetails] = useState(null);
    const [speakerTime, setSpeakerTime] = useState(null);
    const [selectedHour, setSelectedHour] = useState(null);
    const [reservedTime, setReservedTime] = useState(null);
    const [speakerSplittedTime, setSpeakerSplittedTime] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [loder, setLoder] = useState(false);
    const [bookLoder, setBookingLoder] = useState(false);
    const [isFfavorite, setIsFavorite] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [profileLoader, setProfileLoader] = useState(false);
    const [showCalendar, setShowCalendar] = React.useState(false); //change date onClick opens up modal
    //const [cancelButton, setCancelButton] = React.useState(false);
    useEffect(() => {
        if (LocalHostUser.isLearnerSubscribed) {
            if (UserPlan) {
                if (
                    UserPlan.plan.classDuration === "25min" ||
                    UserPlan.plan.classDuration === 25
                ) {
                    setDuration(25);
                } else {
                    setDuration(15);
                }
            }
        } else {
            setDuration(15);
        }
    });
    // useEffect(() => {
    //     autoState && !cancelButton && openModal();
    //     cancelButton && setModalShow(false);
    //     if (!modalShow){
    //         setCancelButton(false);
    //         setCancelButton((prev)=>{return (prev)})
    //     }
    // }, [autoState, cancelButton])

    useEffect(() => {
        initPixel()
        initGA()

        var weeklyDate = [];
        arr2.map((data) => {
            weeklyDate.push(availableDate(data));
        });
        setWeeklyDate(weeklyDate);

        if (FavoriteSpeakers) {
            var data = FavoriteSpeakers.find((element) => element._id === id);
            if (data) {
                setIsFavorite(true);
            }
        }
    }, []);

    const zeroPad = (num, places) => String(num).padStart(places, "0");

    useEffect(() => {
        if (speakerDetails) {
            const times = speakerDayTime(selectedDate, speakerDetails?.timeslot);
            const reservedTimes = speakerDayTime(
                selectedDate,
                speakerDetails?.bookedTimings,
            );

            var TimeArr = [];

            var hr = intervaldate.getHours();
            const today = moment(intervaldate).format("YYYY-MM-DD");
            var changedDate = selectedDate.getFullYear() + "-" + zeroPad((selectedDate.getMonth() + 1), 2) + "-" + zeroPad(selectedDate.getDate(), 2)

            if (today === changedDate) {
                times.map((data) => {
                    var splitedslot = data.split(" - ");
                    if (splitedslot[0] >= zeroPad(hr.toString(), 2) && splitedslot[0] >= "10" && splitedslot[0] <= "24") {
                        TimeArr.push(data);
                    }
                });
            } else {
                times.map((data) => {
                    var splitedslot = data.split(" - ");
                    if (splitedslot[0] >= "10" && splitedslot[0] <= "24") {
                        TimeArr.push(data);
                    }
                });
            }

            setSpeakerTime(TimeArr);
            setSelectedHour(TimeArr[0])
            setReservedTime(reservedTimes);
        }
    }, [selectedDate, speakerDetails]);

    useEffect(() => {

        if (selectedHour) {
            const splittedTime = selectedHour.split("-");
            const times = TimeSpliter(
                `${splittedTime[0].trim()}:00`,
                `${splittedTime[1].trim()}:00`,
                duration
            );
            setSpeakerSplittedTime(times);
        }
    }, [selectedHour]);

    //use Modal
    const openModal = () => {
        setModalShow(true)
        setProfileLoader(true)
        const teacher_data = {
            teacherId: id,
            timezone: time_zone.timezone
        };
        const onSuccess = (data) => {
            setProfileLoader(false)
            console.log(data);
            setSpeakersDetails(data);
        };
        const onError = (data) => {
            setProfileLoader(false)
            if (data.statusCode === 500) {
                setNotFound(true);
            }
        };
        dispatch(SpeakerProfile(teacher_data, onSuccess, onError));
    }

    //add favorite speakers

    const addFavSpeaker = () => {
        setIsFavorite(true);
        const onSuccess = (msg) => {
            openSnackbar(msg);
        };
        const onError = (msg) => {
            openSnackbar(msg);
        };
        dispatch(
            AddFavoriteSpeakers(
                { speakerId: id },
                speakerDetails.teacher,
                onSuccess,
                onError
            )
        );
    };

    //remove favorite speaker
    const removeFavSpeaker = () => {
        setIsFavorite(false);
        const data = {
            speakerId: id,
        };
        const onSuccess = (msg) => {
            openSnackbar(msg);
        };
        const onError = (msg) => {
            openSnackbar(msg);
        };
        dispatch(RemoveFavoriteSpeakers(data, onSuccess, onError));
    };

    //create meeting

    const createMeeting = (teacher, HostData, blockid) => {
        const maindata = {
            userId: HostData,
            data: {
                topic:
                    (LocalHostUser.isDemoPayed === true &&
                        LocalHostUser.isTrialBooked === false) ||
                        isTrialClass
                        ? "Clapingo Demo Session"
                        : "Clapingo Regular Session",
                type: 2,
                start_time: `${getAvailableTeacherSate(
                    selectedDate
                )}T${localToutcTimeConverter(startTime)}:00`,
                duration:
                    (LocalHostUser.isDemoPayed === true &&
                        LocalHostUser.isTrialBooked === false) ||
                        isTrialClass
                        ? 15
                        : duration,
                schedule_for: HostData,
                timezone: "UTC",
                password: "clapingo",
                agenda: "Learn English",
                settings: {
                    host_video: true,
                    participant_video: true,
                    cn_meeting: false,
                    in_meeting: true,
                    join_before_host: true,
                    mute_upon_entry: true,
                    watermark: false,
                    use_pmi: false,
                    approval_type: 2,
                    auto_recording: "cloud",
                    registrants_email_notification: true,
                },
            },
        };

        const onSuccess = (data) => {
            if (data) {
                var meetingndata = {
                    meetingNo: String(data.id),
                    learner: LocalHostUser._id,
                    teacher_: teacher,
                    startTime: TimeValidator(localToutcTimeConverter(startTime)),
                    endTime: TimeValidator(localToutcTimeConverter(endTime)),
                    sessionDate: getAvailableTeacherSate(selectedDate?.toUTCString()),
                    meetingPassword: data.password,
                    startMeetingUrl: data.start_url,
                    joinMeetingUrl: data.join_url,
                    host: data.host_email,
                    isAdmin: false,
                    isWebsite: true,
                    blockHostId: blockid,
                    timezone: time_zone.timezone,
                    isTimeUtc: true,
                };
                if (
                    (LocalHostUser.isDemoPayed === true &&
                        LocalHostUser.isTrialBooked === false) ||
                    isTrialClass
                ) {
                    meetingndata["type"] = "Demo";
                    meetingndata["sessionDuration"] = "15min";
                } else {
                    meetingndata["type"] = "Regular";
                    meetingndata["sessionDuration"] = `${duration}`;
                }

                const onSuccess = () => {
                    setLoder(false);
                    setBookingLoder(false);
                    if (
                        (LocalHostUser.isTrialBooked === false &&
                            LocalHostUser.isDemoPayed === true) ||
                        isTrialClass
                    ) {
                        localStorage.setItem("DEMO_BOOKED", JSON.stringify(true));
                        localStorage.removeItem("DEMO_SESSION");
                        setLoder(false);
                        setBookingLoder(false);
                        history.push("/dashboard");
                        Swal.fire("Demo Booked Successfully!", "", "success");
                        window.location.reload();
                    } else {
                        Swal.fire("Session Booked Successfully!", "", "success");
                        history.push("/dashboard");
                        window.location.reload();
                    }
                };
                const onError = (err) => {
                    setLoder(false);
                    setBookingLoder(false);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: err,
                    });
                };
                dispatch(CreateSession(meetingndata, onSuccess, onError));
            } else {
                setLoder(false);
                setBookingLoder(false);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Unable to book meeting due to some technical reason please try again later",
                });
            }
        };
        const onError = () => {
            setLoder(false);
            setBookingLoder(false);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Oops something went wrong !!",
            });
        };
        dispatch(CreateZoomMeeting(maindata, onSuccess, onError));
    };

    // get available host & call createMeeting

    const BookSession = (teacher) => {
        if (!startTime && !endTime) {
            openSnackbar("Please select a timeslot");
            return;
        }
        setBookingLoder(true);

        if (
            (LocalHostUser.isTrialBooked === false &&
                LocalHostUser.isDemoPayed === true) ||
            isTrialClass
        ) {
            if (!selectedDate && !selectedTime && !startTime && !endTime) {
                openSnackbar("Please select date & time");
                setBookingLoder(false);
            } else {
                const onSuccess = (host, blockid) => {
                    createMeeting(teacher, host, blockid);
                };

                const onError = (msg) => {
                    setBookingLoder(false);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: msg,
                    });
                };

                dispatch(
                    GetAvalableHost(
                        {
                            startTime: TimeValidator(localToutcTimeConverter(startTime)),
                            endTime: TimeValidator(localToutcTimeConverter(endTime)),
                            sessionDate: getAvailableTeacherSate(selectedDate),
                            isTimeUtc: true,
                        },
                        onSuccess,
                        onError
                    )
                );
            }
        } else {
            if (LocalHostUser.isLearnerSubscribed) {
                const onSuccess = (host, blockid) => {
                    createMeeting(teacher, host, blockid);
                };

                const onError = (msg) => {
                    setBookingLoder(false);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: msg,
                    });
                };

                dispatch(
                    GetAvalableHost(
                        {
                            startTime: TimeValidator(localToutcTimeConverter(startTime)),
                            endTime: TimeValidator(localToutcTimeConverter(endTime)),
                            sessionDate: getAvailableTeacherSate(selectedDate),
                            isTimeUtc: true,
                        },
                        onSuccess,
                        onError
                    )
                );
            } else {
                setBookingLoder(false);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Please Subscribe to book the session",
                });
            }
        }
    };

    //mark reserved
    const isOverlapping = (splittedStartTime, splittedEndTime, bookedSessionStartTime, bookedSessionEndTime) => {
        return splittedStartTime <= bookedSessionEndTime && bookedSessionStartTime <= splittedEndTime;
    };

    const AvailableOrNot = (start, end) => {
        var value;
        if (reservedTime) {
            reservedTime.map((data) => {
                var splitedTime = data.split("-");
                if (
                    isOverlapping(
                        splitedTime[0].trim(),
                        splitedTime[1].trim(),
                        start,
                        end
                    )
                ) {
                    value = "Reserved";
                }
            });
        }
        return value;
    };

    console.log(props)
    return (

        <>
            <div>
                {
                    attributeOnClick === "More slots"?
                    <button
                    className="view-speaker"
                    style={{ color: "#4A6EE0" }}
                    onClick={() => openModal()}
                >
                    {attributeOnClick}
                </button>:
                <div className="modalPopupAttribute" onClick={() => openModal()}>{attributeOnClick}</div>
                }
                
            </div>
            {
                showCalendar &&
                <Modal
                    {...props}
                    show={showCalendar}
                    size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >

                    <Modal.Body className="modalBodyForCalendar">
                        {
                            profileLoader ? <Loder /> :

                                <div>
                                    <div className="weekly_date">
                                        <div className="flex">
                                            <div>
                                                <p className="greytitle">Select date:</p>
                                            </div>
                                            <div onClick={() => setShowCalendar(false)}><button className="cancelButton"><i class="fa fa-times-circle closeButtonIcon"></i></button></div>

                                        </div>

                                        <div className="week-card">
                                            {weeklyDate?.map((data, i) => (
                                                <div
                                                    onClick={() => {
                                                        setActiveDate(i);
                                                        setSelectedDate(data.date);
                                                        setSelectedMonth(data.month);
                                                        setSelectedHour(null);
                                                        setActiveSlot(null);
                                                        setSpeakerSplittedTime(null);
                                                        setSelectedTime(null);
                                                        setStartTime(null);
                                                        setEndTime(null);
                                                    }}
                                                    className={`card ${i === activeDate ? "active" : ""}`}
                                                    key={i}
                                                >
                                                    <p>{data.dateNo}</p>
                                                    <p>{data.month}</p>
                                                </div>
                                            ))}
                                        </div>
                                        {/* <img src={swipe} className="swipe-img" alt="swipe"/> */}
                                        <div className="text-center">
                                            <button
                                                className="done-button"
                                                onClick={() => setShowCalendar(false)}
                                            >
                                                Done
                                            </button>
                                        </div>
                                    </div>
                                </div>
                        }
                    </Modal.Body>
                </Modal>
            }
            <Modal
                {...props}
                show={modalShow}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body className="modalSpeakerProfile">
                    <>
                        {loder ? (
                            <div className="loading">
                                <div
                                    className="spinner-border text-white"
                                    style={{ width: "5rem", height: "5rem" }}
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            " "
                        )}
                        <>
                            {speakerDetails === null ? (
                                <div className="col-md-12 mt-5 mb-5">
                                    <Loder message="Fetching Teacher Data ..." />
                                </div>
                            ) : notfound === true ? (
                                <div className="not_found d-flex flex-column justify-content-center align-items-center">
                                    <img src={NotFound} className="not_found_img" alt="Not found" />
                                    <h4>
                                        Speaker not found !{" "}
                                        <span onClick={() => setModalShow(false)}> Back</span>
                                    </h4>
                                </div>
                            ) : (
                                <>
                                    <div className="flex">
                                        <div className="teachername">{speakerDetails?.teacher.name}</div>
                                        <div onClick={() => setModalShow(false)}><button className="cancelButton"><i class="fa fa-times-circle closeButtonIcon"></i></button></div>
                                    </div>
                                    <div className="teacherprofilephoto-aboutmediv flex">
                                        <div className="flex">
                                            <div >
                                                <img
                                                    className="teacherPhoto"
                                                    alt={speakerDetails?.teacher.name}
                                                    src={
                                                        speakerDetails?.teacher.image
                                                            ?
                                                            `https://images.weserv.nl/?url=${speakerDetails.teacher.image}&w=400&h=400&output=webp`
                                                            : emptyTeacher
                                                    }
                                                />
                                                <div className="flex aligncenter">
                                                    <div className="heartLike">
                                                        {isFfavorite ? (
                                                            <div>
                                                                <button
                                                                    className="favorite-btn"
                                                                    onClick={() => {
                                                                        removeFavSpeaker();
                                                                    }}
                                                                >
                                                                    <i className="fas fa-heart"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        {!isFfavorite ? (
                                                            <div>
                                                                <button
                                                                    className="favorite-btn"
                                                                    onClick={() => {
                                                                        addFavSpeaker();
                                                                    }}
                                                                >
                                                                    <i className="far fa-heart"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                    <div><img src={youtubeIcon} /> </div>
                                                </div>
                                            </div>
                                            <div className="ratings">
                                                <div>
                                                    {/* <div className="header3">10</div> */}
                                                    <span>Sessions taken</span></div>
                                                <div className="lineborder"></div>
                                                <div>
                                                    <div className="header3">{speakerDetails?.rating}{" "}
                                                        <i className="fas fa-star text-warning"></i>
                                                    </div><span>Ratings</span>
                                                </div>
                                                <div className="lineborder"></div>
                                                <div>
                                                    <div className="header3">{speakerDetails?.ratingCount}</div><span>Reviews</span></div>
                                            </div>
                                        </div>
                                        <div className="teacher-aboutme">
                                            <h4>About me</h4>
                                            <p>
                                                {speakerDetails?.teacher.description}
                                            </p>

                                        </div>
                                    </div>
                                    <div>
                                        <div className="scheduleThisTutor">Schedule this Tutor</div>
                                        <div className="flex mobileViewSlots">
                                            <div className="descTimeSlots">Showing available time slots for</div>
                                            <div>
                                                <div className="dateSelected">{selectedDate.getDate()} {selectedMonth}, {selectedDate.getFullYear()} <span className="changeDate" onClick={() => { setShowCalendar(!showCalendar) }}>Change Date</span></div>
                                            </div>
                                            <div>
                                                <div className="selectslotDropDown">
                                                    <small>Select a Time Slot : </small>
                                                    {
                                                        speakerTime?.length > 0 ?
                                                            <select
                                                                onChange={(e) => {
                                                                    // setSelectedTime(null);
                                                                    // setStartTime(null);
                                                                    // setEndTime(null);
                                                                    // setActiveSlot(String.fromCharCode(65 + e.target.value));
                                                                    // setSelectedTime(null);
                                                                    // setStartTime(null);
                                                                    // setEndTime(null);
                                                                    if (e.target.value === "23 - 00") {
                                                                        setSelectedHour("23 - 24");
                                                                    } else {
                                                                        setSelectedHour(e.target.value);
                                                                    }
                                                                }}

                                                            >
                                                                {

                                                                    speakerTime?.sort().map((hours, i) => (
                                                                        <option
                                                                            key={i}
                                                                            className={`slot m-md-1 m-1 ${i === activeSlot ? "active" : ""}`}
                                                                            value={hours}
                                                                        >
                                                                            {hours}
                                                                        </option>
                                                                    ))
                                                                }

                                                            </select>
                                                            : <small><strong>No slots Available for now!</strong></small>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex modalTutorDetails">
                                        <div className="">
                                            <div className="schedule">
                                                <div>

                                                    {/* {speakerTime?.length > 0 ? (
                                                        <>
                                                            <div className="d-flex time-slots flex-wrap">
                                                                {speakerTime?.sort().map((hours, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className={`slot m-md-1 m-1 ${i === activeSlot ? "active" : ""}`}
                                                                        onClick={() => {
                                                                            setSelectedTime(null);
                                                                            setStartTime(null);
                                                                            setEndTime(null);
                                                                            setActiveSlot(i);
                                                                            setSelectedTime(null);
                                                                            setStartTime(null);
                                                                            setEndTime(null);
                                                                            if (hours === "23 - 00") {
                                                                                setSelectedHour("23 - 24");
                                                                            } else {
                                                                                setSelectedHour(hours);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {hours === "23 - 00" ? hhformatAMPM("23 - 24") : hhformatAMPM(hours)}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <small>No slots available!</small>
                                                    )} */}
                                                    {speakerSplittedTime?.length > 0 ? (
                                                        <>
                                                            <div className="flex">
                                                                <div className="d-flex time-slots flex-wrap">
                                                                    {speakerSplittedTime?.map((time, i) => (
                                                                        <div
                                                                            key={i}
                                                                            className={`${AvailableOrNot(time.start, time.end) ===
                                                                                "Reserved" ? "disabledreserved" : "slotsecond"} m-md-2 m-1 ${time.timeView === selectedTime ? "active" : ""}`}
                                                                            onClick={() => {
                                                                                if (
                                                                                    AvailableOrNot(time.start, time.end) !==
                                                                                    "Reserved"
                                                                                ) {
                                                                                    setSelectedTime(time.timeView);
                                                                                    setStartTime(time.start);
                                                                                    setEndTime(time.end);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {AvailableOrNot(time.start, time.end) ===
                                                                                "Reserved"
                                                                                ? "Reserved"
                                                                                : formatSpeakerProfileTimeslot(time.timeView)}
                                                                            {/* formatTimeslot */}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className="text-center">
                                                                    <button
                                                                        className={!startTime && !endTime ? "book-button" : "btn bookedButtonenable"}
                                                                        disabled={(!startTime && !endTime) || bookLoder ? true : false}
                                                                        onClick={() => BookSession(id)}

                                                                    >
                                                                        {bookLoder ? "Booking..." : "Book"}
                                                                    </button>
                                                                </div>
                                                            </div>

                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </>)}
                        </>
                    </>
                </Modal.Body>
            </Modal>
        </>

    )
}











